import isEmpty from 'lodash/isEmpty';

import {
  MediaType,
  Post,
} from 'apps/shared/scripts/__generated__/graphql.generated';
import { Image } from 'apps/shared/scripts/components';

import { imageClassName, postMediaClassName } from './styles';

export interface Props {
  media?: Post['media'];
}

const CardPostMedia = ({ media }: Props) => {
  if (!media || isEmpty(media)) {
    return null;
  }

  return (
    <div className={postMediaClassName}>
      <Image
        alt={'post media'}
        className={imageClassName}
        src={
          media.type === MediaType.Giphy
            ? `https://media2.giphy.com/media/${media.src}/giphy.gif`
            : media.src
        }
      />
    </div>
  );
};

CardPostMedia.displayName = 'CardPostMedia';

export default CardPostMedia;
